import React, { useState } from 'react';
import Login from './components/Login';
import VerifyOtp from './components/VerifyOtp';
import MobileInput from './components/MobileInput';

function App() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');

  // Render the appropriate component based on the current step
  const renderStep = () => {
    switch (step) {
      case 1:
        return <Login setStep={setStep} setEmail={setEmail} />;
      case 2:
        return <VerifyOtp email={email} setStep={setStep} />;
      case 3:
        return <MobileInput email={email} setStep={setStep} />;
      default:
        return <Login setStep={setStep} setEmail={setEmail} />;
    }
  };

  return (
    <div className="app">
      {renderStep()}
    </div>
  );
}

export default App;